const keyboardDatePicker = {
  deadline: 'Fecha límite'
};

export default keyboardDatePicker;
